export default "/048cb1f2b29308e18768c65cfd51e426596a830c/74cc88c7571ddfe8037db442e45677ad.svg";